/* eslint-disable max-len */
import http from './http'
import axios, { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import { User } from '../types/user'
import { Schedule } from '../types/schedule'
import { Coach } from '../types/coaches'

export function getUsers(): AxiosPromise<AppApiResponseData<User[]>> {
	return http({
		method: 'POST',
		url: '/p/search/user',
	})
}

export function getUsersOrgSettings(): AxiosPromise<
	AppApiResponseData<Array<Coach>>
> {
	return http({
		method: 'POST',
		url: '/p/search/user',
	})
}

export function getUserData(
	timezoneOffsetInMinutes: number
): AxiosPromise<AppApiResponseData<User>> {
	return http({
		method: 'GET',
		url: `/p/user/login?timezone=${timezoneOffsetInMinutes}`,
	})
}

export function getUserConfigData(
	timezoneOffsetInMinutes: number
): AxiosPromise<AppApiResponseData<any>> {
	return http({
		method: 'GET',
		url: `/p/user?timezone=${timezoneOffsetInMinutes}`,
	})
}

// need fix
export function getUserConfigDataAxios(
	timezoneOffsetInMinutes: number
): AxiosPromise<AppApiResponseData<any>> {
	return axios.get(
		`https://staging-engage.dariohealth.com/api/v1/p/user?timezone=${timezoneOffsetInMinutes}`,
		{
			headers: {
				'x-access-token': localStorage.getItem('access_token') || '',
			},
		}
	)
}

export function todaySchedule(
	date: number,
	timezoneOffsetInMinutes: number,
	includeInactive?: boolean,
	view?: string
): AxiosPromise<AppApiResponseData<Schedule>> {
	return http({
		method: 'POST',
		url: '/p/coach/todaysSchedule',
		data: {
			date,
			offset: timezoneOffsetInMinutes,
			includeInactive,
			view
		},
	})
}

export function createUser(data: User): AxiosPromise<AppApiResponseData<User>> {
	return http({
		method: 'POST',
		url: '/p/user',
		data,
	})
}

export function updateUser(
	data: User,
): AxiosPromise<AppApiResponseData<User>> {
	return http({
		method: 'PUT',
		url: '/p/update/user',
		data,
	})
}
